import { connect } from 'react-redux';
import { Order as OrderComponent } from './order.component';
import { getUserData } from '../../authentication/authentication.actions';

export const Order = connect(sState => ({ sState }), {
  getUserData
})(OrderComponent);